import React, { useContext, useCallback } from 'react';
import Button from '@material-ui/core/Button';

import { AnalogDataLoan, PrivateCopyExistenceRecord } from 'types';

import { OrderCtx } from 'components/order-ctx/order-ctx';

/**
 * Table cell for text value.
 */
export function LentTableActionCell({
  allData,
}: {
  allData: AnalogDataLoan | PrivateCopyExistenceRecord;
}) {
  const { handleAddUnit, isArchivalUnitInOrder } = useContext(OrderCtx);

  const hideReorderButton = (allData as AnalogDataLoan).pendingReservation;

  const disabledReorderButton = isArchivalUnitInOrder?.(
    allData.archivalUnitReference!.numericId
  );

  const handleClick = useCallback(() => {
    handleAddUnit?.(allData.archivalUnitReference!, '');
  }, [allData.archivalUnitReference, handleAddUnit]);

  return (
    <>
      {!hideReorderButton ? (
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={handleClick}
          disabled={disabledReorderButton}
        >
          Objednat znovu
        </Button>
      ) : (
        <Button
          variant="contained"
          color="primary"
          size="small"
          disabled={true}
          onClick={handleClick}
        >
          Archiválie je na cestě
        </Button>
      )}
    </>
  );
}
